// extracted by mini-css-extract-plugin
export var marginNegative = "_6v-5 _6v-3 _6v-1";
export var marginPositive = "_6v-4 _6v-3 _6v-1";
export var modalContent = "_6v-6";
export var samplesTable = "_6v-8";
export var samplesTableContainer = "_6v-7";
export var statBox = "_6v-a";
export var tableCell = "_6v-1";
export var tableCellCenter = "_6v-2 _6v-1";
export var tableCellRight = "_6v-3 _6v-1";
export var tableHeader = "_6v-0";
export var trackingNumber = "_6v-9";